// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import clsx from 'clsx';
import { Transition } from '../transition';
import PopoverContainer from '../../../popover/container';
import PopoverBody from '../../../popover/body';
import Portal from '../portal';
import popoverStyles from '../../../popover/styles.css.js';
import styles from './styles.css.js';
export default function Tooltip({ value, trackRef, contentAttributes = {} }) {
    return (React.createElement(Portal, null,
        React.createElement("div", Object.assign({ className: styles.root }, contentAttributes),
            React.createElement(Transition, { in: true }, () => (React.createElement(PopoverContainer, { trackRef: trackRef, trackKey: value, size: "small", fixedWidth: false, position: "top", arrow: position => (React.createElement("div", { className: clsx(popoverStyles.arrow, popoverStyles[`arrow-position-${position}`]) },
                    React.createElement("div", { className: popoverStyles['arrow-outer'] }),
                    React.createElement("div", { className: popoverStyles['arrow-inner'] }))) },
                React.createElement(PopoverBody, { dismissButton: false, dismissAriaLabel: undefined, onDismiss: undefined, header: undefined }, value)))))));
}
//# sourceMappingURL=index.js.map